import { Link , useLocation, useNavigate } from "react-router-dom"
import { useState, useEffect } from "react"
import Logo from "../../assets/images/logo-header.png"
import styled from "styled-components"
import colors from "../../utils/style/colors.tsx"
import { HashLink } from "react-router-hash-link"

// Prevent unknown props from being passed to the DOM
const StyledLink = styled(Link)`
    color: ${colors.black};
    text-decoration: none;
    font-size: 20px;
    font-family: "Archivo Black", sans-serif;
    display: flex;
    transition: all 0.5s ease;
`

const StyledHashLink = styled(HashLink)`
    color: ${colors.black};
    text-decoration: none;
    font-size: 20px;
    font-family: "Archivo Black", sans-serif;
    display: flex;
    transition: all 0.5s ease;

    @media (max-width: 768px) {
        display: flex;
        justify-content: center;
        padding-bottom: 20px;
        font-size: 14px;
    
    }
`

const MenuContainer = styled.nav`
    border: solid 7px ${colors.dark_red};
    border-radius: 20px;
    box-shadow: 8px 5px ${colors.dark_red};
    display: flex;
    justify-content: space-between;
    margin: 3%;
    width: 92%;
    background-color: ${colors.white};
    top: 0;
    z-index: 10;
    position: absolute;

    @media (max-width: 768px) {
        border: solid 5px ${colors.dark_red};
        box-shadow: 4px 3px ${colors.dark_red};
        width: 90%;
    }
`

const ImageWrapper = styled.div`
    margin-left: 2%;
    display: flex;
`

const ImageNav = styled.img`
    width: 82px;
    height: 100px;
    padding: 10px;
    transition: all 0.5s ease;
    
    ${({ $isscrolled }) => $isscrolled && ``}

    @media (max-width: 768px) {
        width: 55px;
        height: 68px;
    }
`


const NavWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-right: 3%;
    width: 66%;

    @media (max-width: 1000px) {
        width: 70%;
    }

    @media (max-width: 768px) {
        display: none;
    }
`


const NavLinkWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`


const NavWrapperMobile = styled.div`
    display: none;

    @media (max-width: 768px) {
        display: flex;
        width: 100px;
        margin-right: 15px;
        justify-content: center;
        align-items: center;

    }
`


const MenuMobileWhenCloseContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 34px;
    gap: 8px;
    cursor: pointer;
    
`

const MenuMobileWhenOpenContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 34px;
    gap: 8px;
    cursor: pointer;
`

const MenuTrait = styled.span`
    border: solid 2px black;
`

const MenuTraitCroixGauche = styled.span`
    border: solid 2px black;
    transform: rotate(0.63turn);
    position: relative;
    top: 7px;
    width: 36px;
`

const MenuTraitCroixDroite = styled.span`
    border: solid 2px black;
    transform: rotate(0.37turn);
    position: relative;
    bottom: 4.5px;
    width: 36px;
`

const MenuDeroulantWrapper = styled.div`
    border-radius: 0px 0px 20px 20px;
    background-color: ${colors.white};
    position: absolute;
    top: 72px;
    overflow: hidden;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    padding-top: ${({ $isMenuOpen }) => ($isMenuOpen ? "15px" : "15px")};
    z-index: -1;
    display: flex;
    max-height: ${({ $isMenuOpen }) => ($isMenuOpen ? "270px" : "0")};

    /* Appliquer border et box-shadow uniquement si isTransitioning est actif */
    border: ${({ $isTransitioning }) => ($isTransitioning ? "solid 5px #773D3D" : "unset")};
    box-shadow: ${({ $isTransitioning }) => ($isTransitioning ? "4px 3px #773D3D" : "unset")};
    width: ${({ $isTransitioning }) => ($isTransitioning ? "100.1%" : "0")};
    right: ${({ $isTransitioning }) => ($isTransitioning ? "-5px" : "530px")};

    border-top: 0;
    transition: max-height 0.5s ease-in-out;
`


const linkScroll = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    })
}

function Header() {
    const [isscrolled, setisscrolled] = useState(false)
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const [isTransitioning, setIsTransitioning] = useState(false)
    const location = useLocation() // Récupère l'URL actuelle

    const navigate = useNavigate();
    const [animationState, setAnimationState] = useState(""); // Utiliser un état pour l'animation

    const handlePortfolioClick = (e) => {
        e.preventDefault();
        
        // Enregistrer l'état dans le stockage
        localStorage.setItem("rideauFerme", "true"); 
        
        setAnimationState("fermeture"); // Démarrer l'animation de fermeture
        
        setTimeout(() => {
            navigate("/Portfolio"); // Naviguer après l'animation
            setAnimationState("ouverture"); // Passer à l'animation d'ouverture après la navigation
        }, 1500); // Temps aligné avec le CSS
    };
    

    const toggleMenu = () => {
        if (isMenuOpen) {
            // Démarrer un délai avant de cacher border et box-shadow
            setTimeout(() => setIsTransitioning(false), 500)
        } else {
            setIsTransitioning(true) // Dès l'ouverture, activer border et box-shadow
        }
        setIsMenuOpen(!isMenuOpen)
    }

    // Gestion du scroll
    useEffect(() => {
        const handleScroll = () => {
            setisscrolled(window.scrollY > 50)
        }

        window.addEventListener("scroll", handleScroll)
        return () => window.removeEventListener("scroll", handleScroll)
    }, [])

    const contactPath = `${location.pathname}#contact`

    const handleLinkClick = () => {
        linkScroll();
        toggleMenu();
    };

    return (
        <>
            <div className={`rideau ${animationState}`}>  
                {/* <ImageNav
                    src={Logo}
                    alt="Logo"
                    $isscrolled={isscrolled}
                    onClick={linkScroll}
                /> */}
            </div>
            <MenuContainer>
                <ImageWrapper>
                    <StyledLink to="/">
                        <ImageNav
                            src={Logo}
                            alt="Logo"
                            $isscrolled={isscrolled}
                            onClick={linkScroll}
                        />
                    </StyledLink>
                </ImageWrapper>
                <NavWrapper>
                    <NavLinkWrapper>
                        <StyledHashLink
                            onClick={linkScroll}
                            smooth
                            to="/"
                        >
                            Accueil
                        </StyledHashLink>
                        <StyledHashLink
                            onClick={linkScroll}
                            smooth
                            to="/Services"
                        >
                            Mes services
                        </StyledHashLink>
                        <StyledHashLink
                            onClick={linkScroll}
                            smooth
                            to="/Projets"
                        >
                            Mes Projets
                        </StyledHashLink>
                        <StyledHashLink onClick={handlePortfolioClick} smooth to="/Portfolio">
                            Portfolio
                        </StyledHashLink>
                        <StyledHashLink onClick={linkScroll} smooth to={contactPath}>
                            Contact
                        </StyledHashLink>
                    </NavLinkWrapper>
                </NavWrapper>
                <NavWrapperMobile>
                    <div onClick={toggleMenu} style={{ cursor: "pointer" }}>
                        {isMenuOpen ? (
                            <MenuMobileWhenOpenContainer>
                                <MenuTraitCroixGauche />
                                <MenuTraitCroixDroite />
                            </MenuMobileWhenOpenContainer>
                        ) : (
                            <MenuMobileWhenCloseContainer>
                                <MenuTrait />
                                <MenuTrait />
                                <MenuTrait />
                            </MenuMobileWhenCloseContainer>
                        )}
                    </div>
                </NavWrapperMobile>
                <MenuDeroulantWrapper $isMenuOpen={isMenuOpen} $isTransitioning={isTransitioning}>
                    <StyledHashLink onClick={handleLinkClick} smooth to="/">Accueil</StyledHashLink>
                    <StyledHashLink onClick={handleLinkClick} smooth to="/Services">Mes services</StyledHashLink>
                    <StyledHashLink onClick={handleLinkClick} smooth to="/Projets">Mes projets</StyledHashLink>
                    <StyledHashLink onClick={handleLinkClick} smooth to="/Portfolio">Portfolio</StyledHashLink>
                    <StyledHashLink onClick={handleLinkClick} smooth to={contactPath}>Contact</StyledHashLink>
                </MenuDeroulantWrapper>
            </MenuContainer>
        </>
    )
}

export default Header
